





































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
let p: any = ''
let timer: any = ''

@Component({})
export default class SprFestModal extends Vue {
	private visible: boolean = false
	private disabled: boolean = true

	private onCancel() {
		clearTimeout(timer)
		this.visible = false
		this.disabled = true
	}

	private ok() {
		this.onCancel()
		p && p.resolve()
	}

	private show() {
		return new Promise((resolve, reject) => {
			this.visible = true
			p = {
				resolve,
				reject,
			}
		})
	}

	private onScroll() {
		// const wrapper: any = this.$refs.imgWrapper
		// const img: any = this.$refs.content
		// if (img.offsetHeight - wrapper.offsetHeight <= wrapper.scrollTop + 1) {
		// 	this.disabled = false
		// }
	}
}
